import { deleteCookie, getCookie, setCookie } from './cookie';

const ACCESS_TOKEN = 'jwt.access_token';
const REFRESH_TOKEN = 'jwt.refresh_token';
const LOGAS_ACCESS_TOKEN = 'jwt.logas_access_token';
const LOGAS_REFRESH_TOKEN = 'jwt.logas_refresh_token';

export function initTokenStorageOnLoad(): void {
  if (!sessionStorage.getItem(ACCESS_TOKEN) && getCookie(ACCESS_TOKEN)) {
    setAccessToken(getCookie(ACCESS_TOKEN), true);
  }
  if (!sessionStorage.getItem(REFRESH_TOKEN) && getCookie(REFRESH_TOKEN)) {
    sessionStorage.setItem(REFRESH_TOKEN, getCookie(REFRESH_TOKEN));
  }
  if (
    !sessionStorage.getItem(LOGAS_ACCESS_TOKEN) &&
    getCookie(LOGAS_ACCESS_TOKEN)
  ) {
    setLogAsAccessToken(getCookie(LOGAS_ACCESS_TOKEN), true);
  }
  if (
    !sessionStorage.getItem(LOGAS_REFRESH_TOKEN) &&
    getCookie(LOGAS_REFRESH_TOKEN)
  ) {
    sessionStorage.setItem(LOGAS_REFRESH_TOKEN, getCookie(LOGAS_REFRESH_TOKEN));
  }
}

export function storeTokensAfterLogin(
  accessToken: string,
  refreshToken: string,
  rememberMe?: boolean,
): void {
  clearAllTokens();
  setAccessToken(accessToken);
  setRefreshToken(refreshToken, rememberMe);
}

export function storeTokensAfterLogAs(
  accessToken: string,
  refreshToken: string,
) {
  setLogAsAccessToken(accessToken);
  setLogAsRefreshToken(refreshToken);
}

export function resetTokensAfterUnlogAs() {
  clearLogasTokens();
}

function clearTokens() {
  sessionStorage.removeItem(ACCESS_TOKEN);
  sessionStorage.removeItem(REFRESH_TOKEN);
  deleteCookie(ACCESS_TOKEN);
  deleteCookie(REFRESH_TOKEN);
}

function clearLogasTokens() {
  sessionStorage.removeItem(LOGAS_ACCESS_TOKEN);
  sessionStorage.removeItem(LOGAS_REFRESH_TOKEN);
  deleteCookie(LOGAS_ACCESS_TOKEN);
  deleteCookie(LOGAS_REFRESH_TOKEN);
}

function clearAllTokens() {
  clearTokens();
  clearLogasTokens();
}

export function clearTokensAfterLogout() {
  clearAllTokens();
}

export function setAccessTokenByPriority(accessToken: string) {
  if (getLogAsAccessToken()) {
    setLogAsAccessToken(accessToken);
  } else {
    setAccessToken(accessToken);
  }
}

export function setAccessToken(
  accessToken: string,
  sessionStorageOnly?: boolean,
) {
  sessionStorage.setItem(ACCESS_TOKEN, accessToken);
  if (!sessionStorageOnly) {
    setCookie(ACCESS_TOKEN, accessToken);
  }
}

function setRefreshToken(refreshToken: string, rememberMe?: boolean) {
  sessionStorage.setItem(REFRESH_TOKEN, refreshToken);
  setCookie(
    REFRESH_TOKEN,
    refreshToken,
    rememberMe ? 2592000 /* 1 month */ : undefined,
  );
}

export function setLogAsAccessToken(
  accessToken: string,
  sessionStorageOnly?: boolean,
) {
  sessionStorage.setItem(LOGAS_ACCESS_TOKEN, accessToken);
  if (!sessionStorageOnly) {
    setCookie(LOGAS_ACCESS_TOKEN, accessToken);
  }
}

function setLogAsRefreshToken(refreshToken: string) {
  sessionStorage.setItem(LOGAS_REFRESH_TOKEN, refreshToken);
  setCookie(LOGAS_REFRESH_TOKEN, refreshToken);
}

export function getAccessTokenByPriority() {
  return getLogAsAccessToken() || getAccessToken();
}

export function getRefreshTokenByPriority() {
  return getLogAsRefreshToken() || getRefreshToken();
}

export function getAccessToken() {
  return getTokenFromBrowser(ACCESS_TOKEN);
}

export function getLogAsAccessToken() {
  return getTokenFromBrowser(LOGAS_ACCESS_TOKEN);
}

export function getRefreshToken() {
  return getTokenFromBrowser(REFRESH_TOKEN);
}

export function getLogAsRefreshToken() {
  return getTokenFromBrowser(LOGAS_REFRESH_TOKEN);
}

function getTokenFromBrowser(path: string) {
  return sessionStorage.getItem(path) || getCookie(path) || null;
}

export function postLogoutEvent() {
  window.postMessage('alk_logout', window.location.origin);
}

export function addLogoutListener(onLogout: () => void) {
  window.addEventListener(
    'message',
    (event) => {
      if (
        event.origin !== window.location.origin ||
        event.data !== 'alk_logout'
      ) {
        return;
      }
      onLogout();
    },
    false,
  );
}
